<template>
    <div class="top-menu-wrap" :class="'top-menu-theme-' + theme" ref="menuWrap">
        <div class="top-menu-measure" ref="measure" aria-hidden="true">
            <span
                v-for="item in topMenus"
                :key="'measure-' + item.key"
                class="top-menu-measure-item"
                :class="{ 'is-submenu': item.type === 'submenu' }"
            >{{ item.title }}</span>
            <span ref="moreMeasure" class="top-menu-measure-item top-menu-measure-more">···</span>
        </div>
        <div class="top-menu-body">
            <div class="top-menu-main" ref="menuMain">
                <el-menu
                    ref="menu"
                    class="top-menu"
                    :background-color="menuTheme.backgroundColor"
                    :text-color="menuTheme.textColor"
                    :active-text-color="menuTheme.activeTextColor"
                    mode="horizontal"
                    :default-active="actId"
                    :collapse-transition="false"
                    @select="selectMenu"
                    router
                >
                    <template v-for="item in visibleMenus">
                        <el-submenu
                            v-if="item.type === 'submenu'"
                            :index="'' + item.menu.fMenu.id"
                            :key="'v-sub-' + item.key"
                        >
                            <template slot="title">
                                <span>{{ item.menu.fMenu.name }}</span>
                            </template>
                            <el-menu-item
                                v-for="smenu in item.menu.sMenuList"
                                :key="smenu.id"
                                style="padding-left: 30px"
                                :index="'' + smenu.id"
                                :route="smenu.linkurl"
                            >{{ smenu.name }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item
                            v-else
                            :index="'' + item.menu.sMenuList[0].id"
                            :key="'v-item-' + item.key"
                            :route="item.menu.sMenuList[0].linkurl"
                        >{{ item.menu.sMenuList[0].name }}</el-menu-item>
                    </template>
                </el-menu>
            </div>
            <div v-if="overflowMenus.length" class="top-menu-more" ref="moreWrap">
                <el-dropdown
                    trigger="hover"
                    placement="bottom-end"
                    :show-timeout="100"
                    :hide-timeout="200"
                    @command="handleOverflowSelect"
                >
                    <span class="top-menu-more-trigger">
                        <span class="top-menu-more-title">···</span>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="top-menu-more-dropdown">
                        <el-dropdown-item
                            v-for="entry in overflowDropdownItems"
                            :key="entry.key"
                            :disabled="entry.type === 'group'"
                            :class="{
                                'top-menu-more-group': entry.type === 'group',
                                'top-menu-more-child': entry.type === 'child'
                            }"
                            :command="entry.command"
                        >{{ entry.label }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        actId: {
            type: String,
            default() {
                return "0"
            }
        },
        menuData: {
            type: Array,
            default() {
                return []
            },
        },
        isCollapse: {
            type: Boolean,
            default() {
                return false
            }
        },
        theme: {
            type: String,
            default: 'deep',
        },
        rightGap: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            visibleCount: 9999,
            moreWidth: 56,
            resizeObserver: null,
            calcTimer: null,
        }
    },
    computed: {
        menuTheme() {
            // backgroundColor 勿传 'transparent'，否则 Element 会在 hover 时用 JS 写内联背景，CSS 无法覆盖
            return {
                backgroundColor: '',
                textColor: '#ffffff',
                activeTextColor: '#ffffff',
            }
        },
        topMenus() {
            const list = []
            for (const menu of this.menuData) {
                if (menu.fMenu.loner == 0) {
                    list.push({
                        type: "submenu",
                        key: menu.fMenu.id,
                        title: menu.fMenu.name,
                        menu,
                    })
                } else if (menu.fMenu.loner == 1 && menu.fMenu.id != 1910) {
                    list.push({
                        type: "item",
                        key: menu.sMenuList[0].id,
                        title: menu.sMenuList[0].name,
                        menu,
                    })
                }
            }
            return list
        },
        visibleMenus() {
            return this.topMenus.slice(0, this.visibleCount)
        },
        overflowMenus() {
            return this.topMenus.slice(this.visibleCount)
        },
        needMore() {
            return this.overflowMenus.length > 0
        },
        overflowDropdownItems() {
            const items = []
            for (const item of this.overflowMenus) {
                if (item.type === "submenu") {
                    items.push({
                        type: "group",
                        key: "g-" + item.key,
                        label: item.menu.fMenu.name,
                    })
                    for (const smenu of item.menu.sMenuList) {
                        items.push({
                            type: "child",
                            key: "c-" + smenu.id,
                            label: smenu.name,
                            command: this.buildOverflowCommand(
                                smenu.id,
                                item.menu.fMenu.id,
                                smenu.linkurl
                            ),
                        })
                    }
                } else {
                    items.push({
                        type: "item",
                        key: "i-" + item.key,
                        label: item.menu.sMenuList[0].name,
                        command: this.buildOverflowCommand(
                            item.menu.sMenuList[0].id,
                            item.menu.fMenu.id,
                            item.menu.sMenuList[0].linkurl
                        ),
                    })
                }
            }
            return items
        },
    },
    watch: {
        menuData: {
            handler() {
                this.scheduleCalc()
            },
            deep: true,
        },
        needMore() {
            this.$nextTick(() => {
                this.updateMoreWidth()
                this.scheduleCalc()
            })
        },
        rightGap() {
            this.scheduleCalc()
        },
    },
    mounted() {
        this.scheduleCalc()
        if (typeof ResizeObserver !== "undefined" && this.$refs.menuWrap) {
            this.resizeObserver = new ResizeObserver(() => {
                this.scheduleCalc()
            })
            this.resizeObserver.observe(this.$refs.menuWrap)
        } else {
            window.addEventListener("resize", this.scheduleCalc)
        }
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
        window.removeEventListener("resize", this.scheduleCalc)
        if (this.calcTimer) {
            clearTimeout(this.calcTimer)
        }
    },
    methods: {
        scheduleCalc() {
            if (this.calcTimer) {
                clearTimeout(this.calcTimer)
            }
            this.calcTimer = setTimeout(() => {
                this.$nextTick(() => {
                    this.updateMoreWidth()
                    this.calcVisible()
                })
            }, 80)
        },
        updateMoreWidth() {
            const moreMeasure = this.$refs.moreMeasure
            const moreWrap = this.$refs.moreWrap
            let width = 0
            if (moreMeasure) {
                width = moreMeasure.offsetWidth
            }
            if (moreWrap) {
                width = Math.max(width, moreWrap.offsetWidth)
            }
            if (width > 0) {
                this.moreWidth = width
            }
        },
        calcVisible() {
            const wrap = this.$refs.menuWrap
            const measure = this.$refs.measure
            const total = this.topMenus.length
            if (!wrap || !measure || total === 0) {
                this.visibleCount = total
                return
            }
            const containerWidth = Math.max(0, wrap.clientWidth - (this.rightGap || 0))
            if (containerWidth <= 0) {
                return
            }
            const spans = measure.querySelectorAll(".top-menu-measure-item:not(.top-menu-measure-more)")
            const widths = Array.from(spans).map((el) => el.offsetWidth)
            const moreWidth = this.moreWidth

            const sumWidth = (count) => {
                let sum = 0
                for (let i = 0; i < count; i++) {
                    sum += widths[i] || 0
                }
                return sum
            }

            if (sumWidth(total) <= containerWidth) {
                this.visibleCount = total
                return
            }

            // 先为右侧固定的「···」预留宽度，再在剩余空间里排可见项
            const available = Math.max(0, containerWidth - moreWidth)
            let count = total
            while (count > 0 && sumWidth(count) > available) {
                count--
            }
            this.visibleCount = count
        },
        buildOverflowCommand(sMenuIndex, fMenuIndex, linkurl) {
            return {
                sMenuIndex: String(sMenuIndex),
                fMenuIndex,
                linkurl,
            }
        },
        handleOverflowSelect(command) {
            if (!command || !command.sMenuIndex) {
                return
            }
            this.$emit("selectMenu", {
                sMenuIndex: command.sMenuIndex,
                fMenuIndex: command.fMenuIndex,
                menu: 1,
            })
            if (command.linkurl) {
                this.$router.push(command.linkurl)
            }
        },
        selectMenu(key, keyPath) {
            let k = keyPath[0]
            if (keyPath.length == 1) {
                for (const index in this.menuData) {
                    const sMenuList = this.menuData[index].sMenuList
                    for (const sIndex in sMenuList) {
                        if ((sMenuList[sIndex].id + "") == k) {
                            k = this.menuData[index].fMenu.id
                            break
                        }
                    }
                    if (keyPath != k + "") {
                        break
                    }
                }
            }
            this.$emit("selectMenu", { sMenuIndex: key, fMenuIndex: k, menu: 1 })
        },
    },
}
</script>

<style scoped>
.top-menu-wrap {
    flex: 1;
    min-width: 0;
    height: 60px;
}
.top-menu-body {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    height: 100%;
}
.top-menu-main {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}
.top-menu-more {
    flex-shrink: 0;
}
.top-menu {
    border-bottom: none;
}
.top-menu-more-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 0 16px;
    cursor: pointer;
}
/* el-menu--horizontal 与 top-menu 在同一节点上，不能写成 .top-menu .el-menu--horizontal */
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal {
    background-color: transparent !important;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-menu-item {
    min-width: 144px;
    text-align: center;
    padding: 0 20px !important;
    box-sizing: border-box;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu {
    min-width: 144px;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu > .el-submenu__title {
    min-width: 144px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 20px !important;
    box-sizing: border-box;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):not(.is-active):hover,
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu:not(.is-active) > .el-submenu__title:hover {
    background-color: #9EBEE6 !important;
    background-image: none !important;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):not(.is-active):focus,
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu:not(.is-active) > .el-submenu__title:focus {
    background-color: transparent !important;
    background-image: none !important;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-menu-item.is-active,
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu.is-active > .el-submenu__title,
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-menu-item.is-active:hover,
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu.is-active > .el-submenu__title:hover {
    color: #fff !important;
    border-bottom: none !important;
    background-color: transparent !important;
    background-image: var(--theme-menu-active-bg) !important;
    background-repeat: no-repeat;
    background-position: center center;
    /* 按图片原始比例缩放，不铺满、不拉伸，上下留白 */
    background-size: auto 30px;
}
.top-menu-wrap /deep/ .top-menu.el-menu--horizontal > .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
    position: static;
    color: #fff !important;
    font-size: 11px;
    font-weight: bold;
    transform: scale(1.15);
    margin-top: 0;
    margin-left: 4px;
}
.top-menu-theme-deep .top-menu-more-trigger {
    color: #fff;
}
.top-menu-theme-deep .top-menu-more-trigger:hover {
    background-color: rgba(255, 255, 255, 0.12);
}
.top-menu-theme-light .top-menu-more-trigger {
    color: #fff;
}
.top-menu-theme-light .top-menu-more-trigger:hover {
    background-color: rgba(255, 255, 255, 0.12);
}
.top-menu-measure {
    position: absolute;
    visibility: hidden;
    pointer-events: none;
    height: 0;
    overflow: hidden;
    white-space: nowrap;
}
.top-menu-measure-item {
    display: inline-block;
    min-width: 140px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 60px;
    white-space: nowrap;
    text-align: center;
    box-sizing: border-box;
}
.top-menu-measure-item.is-submenu {
    padding-right: 20px;
}
.top-menu-measure-more {
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: bold;
    padding: 0 16px;
}
.top-menu-more-title {
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: bold;
}
</style>
